import { HmacSHA256, enc } from "crypto-js";

export const generateHmac = ({ userId, id }) => {
  const epochTimestamp = Math.floor(Date.now() / 1000)
  const passPhrase = userId;
  const message = `timestamp:${epochTimestamp},id:${id}`;
  const hString = HmacSHA256(message, passPhrase).toString(enc.Hex);
  return { hString, epochTimestamp };
};
